import cx from 'classnames';
import { LocationDescriptor } from 'history';
import lowerFirst from 'lodash-es/lowerFirst';
import { DECLINE_INVITATION, INVITATION_SENT_ON_when, OPEN_INVITATION } from 'mk/autogenerated/translations/ModeratorInvitationListItem.546a59aa47d4de498c1e0616c004e016'
import { UserChip, UserChipPlaceholder } from 'mk2/apps/forum/components/UserChip';
import { Btn, BtnType } from 'mk2/components/Btn';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import { timeAgo } from 'mk2/helpers/timeformat';
import { Role, UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './ModeratorInvitationListItem.mscss';

interface OwnProps {
    className?: string;
    user: UserEntity;
    canDecline: boolean;
    canOpen: boolean;
    openUrl: LocationDescriptor;
    createdAt: string;
    invitationId: number;   // GroupInvitationEntity or TopicModeratorInvitationEntity
    declining?: boolean;
    viewerRole?: Role;

    onDecline(invitationId: number, username: string);
}

type Props = OwnProps;

export class ModeratorInvitationListItem extends React.PureComponent<Props> {
    public static defaultProps: Partial<Props> = {
        declining: false,
        viewerRole: Role.MODERATOR,
    };

    public render() {
        const { className, user, canDecline, canOpen, openUrl, createdAt, declining, viewerRole } = this.props;

        return (
            <div className={cx(styles.ModeratorInvitationListItem, className)}>
                <div className={styles.ModeratorInvitationListItem__left}>
                    <UserChip user={user} size={40} />
                    &ensp;
                    <div className={styles.ModeratorInvitationListItem__note}>
                        (
                        {interpolate(INVITATION_SENT_ON_when, {
                            when: lowerFirst(
                                timeAgo(
                                    createdAt,
                                    process.env.NODE_ENV === 'test' ? new Date('2018-11-21T11:19:47.166Z') : null,
                                    true,
                                ),
                            ),
                        })}
                        )
                    </div>
                </div>
                <div className={styles.ModeratorInvitationListItem__right}>
                    {canOpen && <Btn type={BtnType.BlueOutline} label={OPEN_INVITATION} link={openUrl} />}{' '}
                    {canDecline && (
                        <Btn
                            type={viewerRole === Role.MODERATOR ? BtnType.ModeratorOutline : BtnType.AdminOutline}
                            label={DECLINE_INVITATION}
                            onClick={this.onDecline}
                            hasSpinner={declining}
                            disabled={declining}
                        />
                    )}
                </div>
            </div>
        );
    }

    private onDecline = () => {
        this.props.onDecline(this.props.invitationId, undefined);       // no username - don't display success growl
    };
}

interface ModeratorInvitationListItemPlaceholderOwnProps {
    className?: string;
}

export const ModeratorInvitationListItemPlaceholder: React.StatelessComponent<
    ModeratorInvitationListItemPlaceholderOwnProps
> = ({ className }) => (
    <div className={cx(styles.ModeratorInvitationListItem, className)}>
        <div className={styles.ModeratorInvitationListItem__left}>
            <UserChipPlaceholder size={40} />
            &ensp;
            <div className={styles.ModeratorInvitationListItem__note}>
                (<LoadingPlaceholder width={100} />)
            </div>
        </div>
        <div className={styles.ModeratorInvitationListItem__right}>
            <LoadingPlaceholder width={115} height={34} />
        </div>
    </div>
);
